export default __webpack_public_path__ + "fonts/header_logo.fbb0da19b5ac7c683e512bfb4588c6a5.png";